import { ProgramFeatures } from '@citruscamps/citrus-client'
import { DateTime } from 'luxon'

export const isHistoryViewValid = (date: Date, flags: Pick<ProgramFeatures, 'months_of_history'>) =>
  !flags.months_of_history ||
  (typeof date === 'string' ? DateTime.fromISO(date) : DateTime.fromJSDate(date)) >=
    DateTime.local().minus({ months: flags.months_of_history })
